import sliderPartnerTeaser from '../../../../../../src24/js/modules/sliderPartnerTeaser';
import partnerTeaser from '../../../../../../src24/js/modules/partnerTeaser';

window.addEventListener('load', () => {
    partnerTeaser.init();
    sliderPartnerTeaser.init();
});
